// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3gCwF","title":"AfterBackImages_title__1y5Pn","images":"AfterBackImages_images__3D-VM"};